<template>
  <div>
    <nav-bar />
    <b-container fluid>
      <b-row>
        <b-col>
          <b-overlay :show="loading">
            <v-card>
              <v-card-title>
                <b-row no-gutters align-v="center">
                  <b-col>FORMULÁRIOS DE SEMIOLOGIA</b-col>
                  <b-col cols="auto">
                    <v-btn text color="primary" @click="newForm">
                      <v-icon> mdi-plus </v-icon>
                      NOVO
                    </v-btn>
                  </b-col>
                </b-row>
              </v-card-title>
              <v-card-text>
                <!-- FORMULÁRIOS -->
                <v-expansion-panels flat>
                  <v-expansion-panel
                    v-for="(form, form_index) in forms"
                    :key="`${form_index}`"
                  >
                    <v-expansion-panel-header
                      :disable-icon-rotate="form.hasError"
                    >
                      <template v-if="form.hasError" #actions>
                        <v-icon color="error"> mdi-alert-circle </v-icon>
                      </template>
                      <h4>FORMULÁRIO: {{ form.name }}</h4>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <b-row align-v="center">
                        <b-col cols="auto">
                          <v-btn icon color="red" @click="delForm(form_index)">
                            <v-icon>mdi-trash-can</v-icon>
                          </v-btn>
                        </b-col>
                        <b-col cols="auto">
                          <v-btn
                            :disabled="form_index === 0"
                            icon
                            @click="
                              forms = arraySwapItemPosition(
                                forms,
                                form_index,
                                form_index - 1
                              )
                            "
                          >
                            <v-icon> mdi-arrow-up </v-icon>
                          </v-btn>
                          <v-btn
                            :disabled="form_index === forms.length - 1"
                            icon
                            @click="
                              forms = arraySwapItemPosition(
                                forms,
                                form_index,
                                form_index + 1
                              )
                            "
                          >
                            <v-icon> mdi-arrow-down </v-icon>
                          </v-btn>
                        </b-col>
                        <b-col cols="auto">
                          <v-text-field
                            dense
                            outlined
                            hide-details
                            label="FORMULÁRIO"
                            v-model="form.name"
                          >
                          </v-text-field>
                        </b-col>
                        <b-col cols="auto" class="text-end">
                          <v-btn
                            v-if="selected"
                            color="red"
                            class="text-white"
                            @click="selectFormToEdit(null)"
                          >
                            CANCELAR EDIÇÃO
                          </v-btn>
                          <v-btn
                            v-if="!selected"
                            color="primary"
                            @click="selectFormToEdit(form)"
                          >
                            SELECIONAR FORMULÁRIO PARA EDITAR
                          </v-btn>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <v-textarea
                            dense
                            outlined
                            hide-details
                            label="DESCRIÇÃO"
                            v-model="form.description"
                          ></v-textarea>
                        </b-col>
                      </b-row>
                      <errors-messages :errors="form.errors" />
                      <!-- CATEGORIAS -->
                      <b-row>
                        <b-col>
                          <v-btn depressed @click="newCategory(form)">
                            <v-icon>mdi-plus</v-icon>
                            CATEGORIA
                          </v-btn>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <v-expansion-panels accordion flat>
                            <v-expansion-panel
                              v-for="(
                                category, category_index
                              ) in form.categories"
                              :key="`${form_index}.${category_index}`"
                            >
                              <v-expansion-panel-header
                                :disable-icon-rotate="category.hasError"
                              >
                                <template v-if="category.hasError" #actions>
                                  <v-icon color="error">
                                    mdi-alert-circle
                                  </v-icon>
                                </template>
                                <h5>CATEGORIA: {{ category.name }}</h5>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <b-row align-v="center">
                                  <b-col
                                    cols="auto"
                                    @click="delCategory(form, category_index)"
                                  >
                                    <v-btn icon color="red">
                                      <v-icon>mdi-trash-can</v-icon>
                                    </v-btn>
                                  </b-col>
                                  <b-col cols="auto">
                                    <v-btn
                                      :disabled="category_index === 0"
                                      icon
                                      @click="
                                        form.categories = arraySwapItemPosition(
                                          form.categories,
                                          category_index,
                                          category_index - 1
                                        )
                                      "
                                    >
                                      <v-icon> mdi-arrow-up </v-icon>
                                    </v-btn>
                                    <v-btn
                                      :disabled="
                                        category_index ===
                                        form.categories.length - 1
                                      "
                                      icon
                                      @click="
                                        form.categories = arraySwapItemPosition(
                                          form.categories,
                                          category_index,
                                          category_index + 1
                                        )
                                      "
                                    >
                                      <v-icon> mdi-arrow-down </v-icon>
                                    </v-btn>
                                  </b-col>
                                  <b-col cols="6">
                                    <v-text-field
                                      dense
                                      outlined
                                      hide-details
                                      label="CATEGORIA"
                                      v-model="category.name"
                                    >
                                    </v-text-field>
                                  </b-col>
                                </b-row>
                                <errors-messages :errors="category.errors" />
                                <!-- PERGUNTAS -->
                                <b-row>
                                  <b-col>
                                    <v-btn
                                      depressed
                                      @click="newQuestion(category)"
                                    >
                                      <v-icon>mdi-plus</v-icon>
                                      PERGUNTA
                                    </v-btn>
                                  </b-col>
                                </b-row>
                                <b-row>
                                  <b-col>
                                    <v-expansion-panels accordion flat>
                                      <v-expansion-panel
                                        v-for="(
                                          question, question_index
                                        ) in category.questions"
                                        :key="`${form_index}.${category_index}.${question_index}`"
                                      >
                                        <v-expansion-panel-header
                                          :disable-icon-rotate="
                                            question.hasError
                                          "
                                        >
                                          <template
                                            v-if="question.hasError"
                                            #actions
                                          >
                                            <v-icon color="error">
                                              mdi-alert-circle
                                            </v-icon>
                                          </template>
                                          <h6>
                                            PERGUNTA: {{ question.statement }}
                                          </h6>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                          <b-row align-v="center">
                                            <b-col cols="auto">
                                              <v-btn
                                                icon
                                                color="red"
                                                @click="
                                                  delQuestion(
                                                    category,
                                                    question_index
                                                  )
                                                "
                                              >
                                                <v-icon>mdi-trash-can</v-icon>
                                              </v-btn>
                                            </b-col>
                                            <b-col cols="auto">
                                              <v-btn
                                                :disabled="question_index === 0"
                                                icon
                                                @click="
                                                  category.questions =
                                                    arraySwapItemPosition(
                                                      category.questions,
                                                      question_index,
                                                      question_index - 1
                                                    )
                                                "
                                              >
                                                <v-icon> mdi-arrow-up </v-icon>
                                              </v-btn>
                                              <v-btn
                                                :disabled="
                                                  question_index ===
                                                  category.questions.length - 1
                                                "
                                                icon
                                                @click="
                                                  category.questions =
                                                    arraySwapItemPosition(
                                                      category.questions,
                                                      question_index,
                                                      question_index + 1
                                                    )
                                                "
                                              >
                                                <v-icon>
                                                  mdi-arrow-down
                                                </v-icon>
                                              </v-btn>
                                            </b-col>
                                            <b-col cols="3">
                                              <v-select
                                                dense
                                                outlined
                                                hide-details
                                                label="TIPO"
                                                :items="question_types"
                                                v-model="question.type_value"
                                                item-text="name"
                                                item-value="value"
                                              >
                                              </v-select>
                                            </b-col>
                                            <b-col cols="5">
                                              <v-text-field
                                                dense
                                                outlined
                                                hide-details
                                                label="ENUNCIADO"
                                                v-model="question.statement"
                                              >
                                              </v-text-field>
                                            </b-col>
                                            <b-col>
                                              <v-checkbox
                                                label="OBRIGATÓRIA"
                                                :value="1"
                                                :false-value="0"
                                                v-model="question.mandatory"
                                              ></v-checkbox>
                                            </b-col>
                                          </b-row>
                                          <errors-messages
                                            :errors="question.errors"
                                          />
                                          <!-- ALTERNATIVAS -->
                                          <b-row>
                                            <b-col>
                                              <v-btn
                                                depressed
                                                @click="
                                                  newAlternative(question)
                                                "
                                              >
                                                <v-icon>mdi-plus</v-icon>
                                                ALTERNATIVA
                                              </v-btn>
                                            </b-col>
                                          </b-row>
                                          <b-row
                                            no-gutters
                                            class="mx-4"
                                            v-for="(
                                              alternative, alternative_index
                                            ) in question.alternatives"
                                            :key="`${form_index}.${category_index}.${question_index}.${alternative_index}`"
                                          >
                                            <b-col>
                                              <b-row align-v="center">
                                                <b-col cols="auto">
                                                  <v-btn
                                                    icon
                                                    color="red"
                                                    @click="
                                                      delAlternative(
                                                        question,
                                                        alternative_index
                                                      )
                                                    "
                                                  >
                                                    <v-icon
                                                      >mdi-trash-can</v-icon
                                                    >
                                                  </v-btn>
                                                </b-col>
                                                <b-col cols="auto">
                                                  <v-btn
                                                    :disabled="
                                                      alternative_index === 0
                                                    "
                                                    icon
                                                    @click="
                                                      question.alternatives =
                                                        arraySwapItemPosition(
                                                          question.alternatives,
                                                          alternative_index,
                                                          alternative_index - 1
                                                        )
                                                    "
                                                  >
                                                    <v-icon>
                                                      mdi-arrow-up
                                                    </v-icon>
                                                  </v-btn>
                                                  <v-btn
                                                    :disabled="
                                                      alternative_index ===
                                                      question.alternatives
                                                        .length -
                                                        1
                                                    "
                                                    icon
                                                    @click="
                                                      question.alternatives =
                                                        arraySwapItemPosition(
                                                          question.alternatives,
                                                          alternative_index,
                                                          alternative_index + 1
                                                        )
                                                    "
                                                  >
                                                    <v-icon>
                                                      mdi-arrow-down
                                                    </v-icon>
                                                  </v-btn>
                                                </b-col>
                                                <b-col cols="6">
                                                  <v-text-field
                                                    dense
                                                    outlined
                                                    hide-details
                                                    label="ALTERNATIVA"
                                                    v-model="alternative.label"
                                                  >
                                                  </v-text-field>
                                                </b-col>
                                                <b-col></b-col>
                                                <b-col
                                                  cols="auto"
                                                  v-if="
                                                    alternative.errors.length >
                                                    0
                                                  "
                                                >
                                                  <v-icon color="error">
                                                    mdi-alert-circle
                                                  </v-icon>
                                                </b-col>
                                              </b-row>
                                              <errors-messages
                                                :errors="alternative.errors"
                                              />
                                            </b-col>
                                          </b-row>
                                        </v-expansion-panel-content>
                                      </v-expansion-panel>
                                    </v-expansion-panels>
                                  </b-col>
                                </b-row>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </b-col>
                      </b-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <errors-messages :errors="errors" />
              </v-card-text>
              <v-card-actions>
                <b-row no-gutters align-h="end">
                  <b-col cols="auto">
                    <v-btn text color="green" @click="validate">
                      <v-icon> mdi-check </v-icon>
                      SALVAR
                    </v-btn>
                  </b-col>
                </b-row>
              </v-card-actions>
            </v-card>
          </b-overlay>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import api from "../services/api";
import NavBar from "../templates/NavBar.vue";
import { arraySwapItemPosition } from "../lib/functions";
import { validateString } from "../lib/validate";
import ErrorsMessages from "../templates/components/ErrorsMessages.vue";
import toast from "../components/ToastNotification";

export default {
  name: "RestHomeSemiologyForms",

  components: { NavBar, ErrorsMessages },

  data() {
    return {
      errors: [],
      loading: false,

      question_types: [],

      /**
       * @type {{
       *   name: string,
       *   description: string,
       *   errors: string[],
       *   hasError: boolean,
       *   categories: {
       *     name: string,
       *     errors: string[],
       *     hasError: boolean,
       *     questions: {
       *       statement: string,
       *       mandatory: boolean,
       *       errors: string[],
       *       hasError: boolean,
       *       type_value: string,
       *       alternatives: {
       *         label: string,
       *         errors: string[],
       *       }[],
       *     }[],
       *   }[],
       * }[]}
       */
      semiology_forms: [],
      forms: [],
      selected: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    arraySwapItemPosition,

    selectFormToEdit(form) {
      if (form) {
        this.selected = form;
        this.forms = [{ ...form }];
      } else {
        this.selected = null;
        this.forms = this.semiology_forms;
      }
    },

    async retrieve() {
      await this.getQuestionTypes();
      await this.getForms();
    },

    async getQuestionTypes() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/semiology/form/question-types"
        );
        const { error, errors, question_types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.question_types = question_types;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async newForm() {
      let selected = {
        key: this.semiology_forms.length + 1,
        name: "",
        description: "",
        errors: [],
        categories: [],
      };

      this.selected = selected;
      this.forms = [{ ...selected }];
      this.semiology_forms.push({ ...selected });
    },

    async delForm(form_index) {
      this.semiology_forms.splice(form_index, 1);
    },

    async newCategory(form) {
      form.categories.push({
        name: "",
        errors: [],
        questions: [],
      });
    },

    async delCategory(form, category_index) {
      form.categories.splice(category_index, 1);
    },

    async newQuestion(category) {
      category.questions.push({
        statement: "",
        mandatory: true,
        errors: [],
        type_value: this.question_types[0].value,
        alternatives: [],
      });
    },

    async delQuestion(category, question_index) {
      category.questions.splice(question_index, 1);
    },

    async newAlternative(question) {
      question.alternatives.push({
        label: "",
        errors: [],
      });
    },

    async delAlternative(question, alternative_index) {
      question.alternatives.splice(alternative_index, 1);
    },

    async getForms() {
      try {
        this.loading = true;
        this.selected = null;

        const response = await api.get(
          "/admin/rest-home-deploy-script/semiology-forms"
        );
        const { error, errors, semiology_forms } = response.data;

        if (error) {
          this.errors = errors;
          this.semiology_forms = [];
          this.forms = [];
        } else {
          let key = 12;
          for (let form of semiology_forms) {
            form.key = key;
            key++;
          }

          this.semiology_forms = semiology_forms;
          this.forms = semiology_forms;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async validate() {
      try {
        this.loading = true;

        let { semiology_forms, forms, selected } = this;

        let toValidates = [];
        if (selected && forms.length > 0) {
          toValidates = forms;
        } else {
          toValidates = semiology_forms;
        }

        //#region validação
        let valid = true;
        let reason;
        //#region formulário
        for (let form of toValidates) {
          form.errors = [];
          form.hasError = false;
          let mandatory_question_constraint_complied = false;

          reason = validateString(form.name, {
            minLength: {
              expected: 3,
              reason: "Nome do formulário deve conter ao menos 3 caracteres",
            },
            maxLength: {
              expected: 64,
              reason: "Nome do formulário deve conter até 64 caracteres",
            },
          });
          if (reason) form.errors.push(reason);

          reason = validateString(form.description, {
            minLength: {
              expected: 3,
              reason:
                "Descrição do formulário deve conter ao menos 3 caracteres",
            },
            maxLength: {
              expected: 255,
              reason: "Descrição do formulário deve conter até 255 caracteres",
            },
          });
          if (reason) form.errors.push(reason);

          if (form.categories.length === 0)
            form.errors.push("Ao menos 1 categoria é necessária");

          //#region categorias
          for (const category of form.categories) {
            category.errors = [];
            category.hasError = false;

            reason = validateString(category.name, {
              minLength: {
                expected: 3,
                reason: "Nome da categoria deve conter ao menos 3 caracteres",
              },
              maxLength: {
                expected: 64,
                reason: "Nome da categoria deve conter até 64 caracteres",
              },
            });
            if (reason) category.errors.push(reason);

            if (category.questions.length === 0)
              category.errors.push(
                "Ao menos 1 pergunta por categoria é necessária"
              );

            //#region perguntas
            for (let question of category.questions) {
              question.errors = [];
              question.hasError = false;

              if (question.mandatory)
                mandatory_question_constraint_complied = true;

              reason = validateString(question.statement, {
                minLength: {
                  expected: 3,
                  reason:
                    "Enunciado da pergunta deve conter ao menos 3 caracteres",
                },
                maxLength: {
                  expected: 255,
                  reason:
                    "Enunciado da pergunta deve conter até 255 caracteres",
                },
              });
              if (reason) question.errors.push(reason);

              //#region tipo de pergunta
              if (question.type_value === "OPEN") {
                if (question.alternatives.length < 1)
                  question.errors.push(
                    "1 alternativa é obrigatória em perguntas abertas"
                  );
                else if (question.alternatives.length > 1)
                  question.errors.push(
                    "Somente 1 alternativa é permitida em perguntas abertas"
                  );
              } else if (question.type_value === "DICHOTOMOUS") {
                if (question.alternatives.length < 2)
                  question.errors.push(
                    "2 alternativa são obrigatórias em perguntas dicotômicas"
                  );
                else if (question.alternatives.length > 2)
                  question.errors.push(
                    "Somente 2 alternativa são permitidas em perguntas dicotômicas"
                  );
              } else if (question.type_value === "MULTIPLE_CHOICE") {
                if (question.alternatives.length < 2)
                  question.errors.push(
                    "Ao menos 2 alternativas são necessárias em perguntas de múltipla escolha"
                  );
                else if (question.alternatives.length > 50)
                  question.errors.push(
                    "No máximo 50 alternativas são permitidas em perguntas de múltipla escolha"
                  );
              } else if (question.type_value === "SINGLE_CHOICE") {
                if (question.alternatives.length < 2)
                  question.errors.push(
                    "Ao menos 2 alternativas são necessárias em perguntas de escolha única"
                  );
                else if (question.alternatives.length > 50)
                  question.errors.push(
                    "No máximo 50 alternativas são permitidas em perguntas de escolha única"
                  );
              } else if (question.type_value === "RATING") {
                if (question.alternatives.length < 2)
                  question.errors.push(
                    "Ao menos 2 alternativas são necessárias em perguntas de classificação"
                  );
                else if (question.alternatives.length > 50)
                  question.errors.push(
                    "No máximo 50 alternativas são permitidas em perguntas de classificação"
                  );
              } else {
                question.errors.push("Tipo de pergunta inválida");
              }
              //#endregion

              //#region alternativas
              for (let alternative of question.alternatives) {
                alternative.errors = [];

                reason = validateString(alternative.label, {
                  minLength: {
                    expected: 1,
                    reason: "Alternativa deve conter ao menos 1 caractere",
                  },
                  maxLength: {
                    expected: 64,
                    reason: "Alternativa deve conter até 64 caractere",
                  },
                });
                if (reason) alternative.errors.push(reason);

                if (alternative.errors.length > 0) {
                  form.hasError = true;
                  category.hasError = true;
                  question.hasError = true;
                  valid = false;
                }
              }
              //#endregion

              if (question.errors.length > 0) {
                form.hasError = true;
                category.hasError = true;
                question.hasError = true;
                valid = false;
              }
            }
            //#endregion

            if (category.errors.length > 0) {
              category.hasError = true;
              form.hasError = true;
              valid = false;
            }
          }
          //#endregion

          if (!mandatory_question_constraint_complied)
            form.errors.push("Ao menos 1 pergunta obrigatória é necessária");

          if (form.errors.length > 0) {
            form.hasError = true;
            valid = false;
          }
        }
        //#endregion

        if (!valid) {
          this.loading = false;
          return;
        }
        //#endregion

        let validateds = [];

        for (let form of semiology_forms) {
          if (selected && forms.length > 0 && form.key == selected.key) {
            validateds.push(forms[0]);
          } else {
            validateds.push(form);
          }
        }

        const data = { semiology_forms: validateds };
        const response = await api.patch(
          "/admin/rest-home-deploy-script/semiology-forms",
          data
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.getForms();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
.v-expansion-panels--flat:not(:empty) {
  border: 2px solid #f5f5f5;
}

.v-expansion-panel--active:not(:first-child) {
  border-top: 2px solid #f5f5f5;
}

.v-expansion-panel--active:not(:last-child) {
  border-bottom: 2px solid #f5f5f5;
}

.v-input--checkbox label {
  margin: 0;
}
</style>